<template>
  <a
    v-if="activityEnded"
    :href="playbackUrl"
    target="_blank"
    :class="$style.container">
    <font-awesome-icon :icon="faPlayCircle" title="Open" v-tippy />
  </a>
</template>

<script>
import { jiminnyHost } from '@/helpers/region'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPlayCircle } from '@fortawesome/pro-light-svg-icons/faPlayCircle'

export default {
  components: {
    FontAwesomeIcon
  },
  props: [
    'activity'
  ],
  data () {
    return {
      faPlayCircle
    }
  },
  computed: {
    playbackUrl () {
      return `${jiminnyHost()}/playback/${this.activity.id}?apFrom=0`
    },
    activityEnded () {
      return !!this.activity.actualEndTime
    }
  }
}
</script>

<style module>
.container {
  color: inherit;
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// PlayButton.vue?d6176960